import React from 'react';
import { LocaleService, ConfigsService } from '@sm360/widget-commons-core-services';
import { AccountService } from '@sm360/widget-commons-general';
import { InputCurrency, Card, CardSection } from '@sm360/ui-library';
import ActionButton from '../../../Components/ActionButton/ActionButton.jsx';

const AppraisalCard = ({
    value,
    onSaveEstimate,
    onMakeAppointment,
    onSelfInspect,
    isActive,
    fetching = false,
    selectedOption,
    tradeInVehicle,
}) => {
    const lang = LocaleService.getSimpleLocale();

    /* TO DO: remove this flag once the pilot testing for Audi Downtown Vancouver is done */
    const isPilotAudiDowntownVancouverOrBmwRegina =
        ConfigsService.getOrganizationUnitId() === 1701 || ConfigsService.getOrganizationUnitId() === 1716;
    return (
        <section className={`appraisal-form--current-option clearfix ${isActive ? 'card-active' : ''}`}>
            <div className="appraisal-form--current-option--inner-container">
                <h4>{LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.VALUE')}</h4>
                {Number.isInteger(value) ? (
                    <InputCurrency
                        value={value}
                        className="appraisal-form--current-option--inner-container--estimation"
                        locale={lang}
                        displayAsText
                    />
                ) : (
                    <div className="appraisal-form--current-option--inner-container--estimation">
                        <div>{lang === 'fr' ? 'XX XXX $' : '$ XX,XXX'}</div>
                        <Card color="alert" outline>
                            <CardSection>
                                <p className="uk-card--fail">
                                    {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.FAIL')}
                                </p>
                            </CardSection>
                        </Card>
                    </div>
                )}
                <p className="sr-text">{LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.CONFIRMATION')}</p>
                {AccountService.isAuthenticated() && (
                    <p className="appraisal-form--current-option--inner-container--saved-estimation-txt">
                        {LocaleService.t('TRADE_IN.SECTIONS_CONTENT.VEHICLE_APPRAISAL.ESTIMATE_SAVED')}
                    </p>
                )}
                <div className="vehicle-buttons-container">
                    <div className="vehicle-buttons">
                        <ActionButton
                            next
                            noPrefix
                            noArrow
                            noSubmit
                            onClick={() => onSaveEstimate()}
                            checkedIcon={AccountService.isAuthenticated()}
                            disabled={AccountService.isAuthenticated()}
                            loading={fetching}
                        >
                            {LocaleService.t('TRADE_IN.BUTTONS.SAVE_ESTIMATE')}
                        </ActionButton>
                        <ActionButton
                            next
                            noPrefix
                            noArrow
                            noSubmit
                            onClick={() => onMakeAppointment()}
                            loading={fetching}
                        >
                            {LocaleService.t('TRADE_IN.BUTTONS.MAKE_APPOINTMENT')}
                        </ActionButton>
                        {/* TO DO: remove this flag once the pilot testing for Audi Downtown Vancouver is done */}
                        {isPilotAudiDowntownVancouverOrBmwRegina && (
                            <ActionButton
                                next
                                noPrefix
                                noArrow
                                noSubmit
                                onClick={onSelfInspect}
                                loading={fetching}
                                id="self-inspect-pave"
                                data-firstname={tradeInVehicle?.contact?.firstname}
                                data-lastname={tradeInVehicle?.contact?.lastname}
                                data-phone={tradeInVehicle?.contact?.phone}
                                data-appraisal-amount={tradeInVehicle?.estimation?.amount}
                                data-preferred-option={selectedOption}
                            >
                                {LocaleService.t('TRADE_IN.BUTTONS.SELF_INSPECT')}
                            </ActionButton>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AppraisalCard;

AppraisalCard.displayName = 'AppraisalCard';
